import { useTranslation } from 'react-i18next';

export const ErrorComponent = ({ errorText }: { errorText: string }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    return (
        <p className='error-component w-100 fw-bolder text-muted bg-light p-5 text-center'>
            {t('errorText', { errorText: errorText.toLowerCase() })}
        </p>
    );
};
